import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';

const flexStandar = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

// const verticalSpan = {
//   transform: 'rotate(-90deg)',
//   width: '55px',
//   lineHeight: '15px',
//   fontSize: '12px',
// };

const destinationCss = {
  position: 'absolute',
  fontSize: '14px',
  fontWeight: 'bold',
  left: '10px',
  bottom: '10px',
};
const originCss = {
  position: 'absolute',
  fontSize: '14px',
  fontWeight: 'bold',
  right: '10px',
  top: '10px',
};

const tableCellCustomHeaderCss = {
  backgroundColor: '#E6E6E6',
  border: '2px white solid',
};

const spanCss = {
  flex: '0.5',
  padding: '0 10px',
  fontSize: '14px',
};

const CustomHeader = styled('div')(() => ({
  ...flexStandar,
  flexDirection: 'column',
}));

const DividedHeader = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '50px',
}));

const stickyStyles = {
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

function DesktopTable({ loading, columns, rows, totalRow }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <>
      <TableContainer style={{ minHeight: '300px', height: '50vh' }}>
        <Table
          aria-label="sticky table"
          style={{
            tableLayout: 'fixed',
            overflowX: 'auto',
            borderCollapse: 'separate',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={2}
                style={{
                  ...tableCellCustomHeaderCss,
                  ...stickyStyles,
                  zIndex: 2,
                  left: 0,
                  padding: 0,
                  width: '300px',
                }}
              >
                <CustomHeader>
                  <DividedHeader>
                    <span style={destinationCss}>Destino</span>
                    <span style={originCss}>Origen</span>
                    <div
                      style={{
                        backgroundColor: 'white',
                        width: '100%',
                        height: '100%',
                        clipPath: 'polygon(0 0, 100% 95%, 100% 100%, 0 5%)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                      }}
                    ></div>
                  </DividedHeader>
                  <div
                    style={{
                      ...flexStandar,
                      border: '2px solid white',
                      width: '100%',
                    }}
                  >
                    <span style={spanCss}>Población</span>
                    <span style={spanCss}>Departamento</span>
                  </div>
                </CustomHeader>
              </TableCell>
              {/* <TableCell
                style={{
                  ...tableCellCustomHeaderCss,
                  padding: 0,
                  width: '50px',
                  ...stickyStyles,
                  left: '304px',
                  zIndex: 12,
                  fontSize: '14px',
                }}
              >
                <div style={verticalSpan}>
                  Tipo <br />
                  Población
                </div>
              </TableCell> */}
              {columns.map((column, index) => {
                return (
                  <TableCell
                    key={`${column.id}_${index}`}
                    align={'center'}
                    style={{
                      ...tableCellCustomHeaderCss,
                      width: '90px',
                      ...stickyStyles,
                      fontSize: '14px',
                      padding: '5px',
                    }}
                  >
                    {column.label}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading === true ? (
              <TableRow hover role="checkbox" tabIndex={-1} align={'center'}>
                <h3>Cargando...</h3>
              </TableRow>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      <TableCell
                        align={'left'}
                        style={{
                          position: 'sticky',
                          left: '0',
                          backgroundColor: 'white',
                          fontSize: '14px',
                        }}
                      >
                        {row[0].destination}
                      </TableCell>
                      <TableCell
                        align={'left'}
                        style={{
                          position: 'sticky',
                          left: '152px',
                          backgroundColor: 'white',
                          fontSize: '14px',
                        }}
                      >
                        {row[0].destination_state}
                      </TableCell>
                      {/* <TableCell
                        align={'left'}
                        style={{
                          position: 'sticky',
                          left: '304px',
                          backgroundColor: 'white',
                          fontSize: '14px',
                          textAlign: 'center',
                          padding: '0px',
                        }}
                      >
                        {row[0].destination_poblation_type_merch}
                      </TableCell> */}
                      {columns.map((column, index) => {
                        const value = row.find(
                          (x) => x.origin === column.label
                        )[column.id];

                        return (
                          <TableCell
                            key={`${column.id}_${index}`}
                            align={column.align}
                          >
                            {column.format ? column.format(value) : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
            )}
            {Array.isArray(totalRow) && (
              <TableRow hover tabIndex={-1} key={totalRow[0].id}>
                {columns.map((column, index) => {
                  const value = totalRow[0][column.id];
                  return (
                    <TableCell
                      key={`${column.id}_${index}`}
                      align={column.align}
                    >
                      <strong>
                        {column.format ? column.format(value) : value}
                      </strong>
                    </TableCell>
                  );
                })}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage={'Filas por página'}
        labelDisplayedRows={({ from, to, count }) => {
          return `${from}–${to} de ${count !== -1 ? count : `mas de ${to}`}`;
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

DesktopTable.propTypes = {
  loading: PropTypes.bool,
  columns: PropTypes.array,
  rows: PropTypes.array,
  totalRow: PropTypes.number,
};

export default DesktopTable;
